interface Props {
  title: string;
  open: boolean;
  onToggleOpen: () => void;
  // Sizing du conteneur (flex-grow/shrink/basis + minHeight) décidé par le parent, qui
  // orchestre le split-view entre toutes les rubriques — voir RepoViewPage.
  style?: React.CSSProperties;
  bodyStyle?: React.CSSProperties;
  rootRef?: (el: HTMLDivElement | null) => void;
  children: React.ReactNode;
}

export function SidebarSection({ title, open, onToggleOpen, style, bodyStyle, rootRef, children }: Props) {
  return (
    <div className="sidebar-section" style={style} ref={rootRef}>
      <button className="sidebar-section-header" onClick={onToggleOpen}>
        <span className={`sidebar-section-chevron${open ? ' open' : ''}`}>›</span>
        <span className="sidebar-section-title">{title}</span>
      </button>
      {open && <div className="sidebar-section-body" style={bodyStyle}>{children}</div>}
    </div>
  );
}
